export enum AppRole {
  Admin = 'Admin',
  InvoiceManager = 'InvoiceManager',
  PartnerDataManager = 'PartnerDataManager',
  IntegrationManager = 'IntegrationManager',
}

export enum AppRoleCountries {
  UK = 'UK',
  US = 'US',
  NL = 'NL',
  DE = 'DE',
  BE = 'BE',
  JP = 'JP',
}
